import {
  CommunicationPreferencesView,
  NotificationType,
  useCommunicationPreferencesViewCreator,
} from '@viewCreators/CommunicationPreferencesViewCreator';
import { useEffect, useState } from 'react';
import {
  RawCommunicationPreference,
  useSaveCommunicationPreferencesAction,
} from '@actions/SaveCommunicationPreferencesAction';
import { useNavigate } from 'react-router-dom';

export const usePreferencesController = () => {
  const { data, refetch, isLoading } = useCommunicationPreferencesViewCreator();
  const { mutateAsync: action } = useSaveCommunicationPreferencesAction();
  const [view, setView] = useState<CommunicationPreferencesView[]>([]);
  const navigator = useNavigate();

  useEffect(() => {
    if (!isLoading && data) setView(data);
  }, [isLoading, data]);

  const onNotificationChanged = (
    e: React.ChangeEvent,
    value: { preferenceId: number; notificationType: NotificationType }
  ) => {
    for (const item of view) {
      if (item.id === value.preferenceId) {
        if (value.notificationType === NotificationType.EMAIL) {
          item.checked.email = !item.checked.email;
        }
        if (value.notificationType === NotificationType.PUSH) {
          item.checked.push = !item.checked.push;
        }
        if (value.notificationType === NotificationType.SMS) {
          item.checked.SMS = !item.checked.SMS;
        }
      }
      setView([...view]);
    }
  };

  const onSave = async () => {
    const raw = view.reduce((items, item, index) => {
      if (item.checked.email) {
        items.push({
          notificationPreferenceId: item.id,
          notificationTypeId: NotificationType.EMAIL,
        });
      }
      if (item.checked.push) {
        items.push({
          notificationPreferenceId: item.id,
          notificationTypeId: NotificationType.PUSH,
        });
      }
      if (item.checked.SMS) {
        items.push({
          notificationPreferenceId: item.id,
          notificationTypeId: NotificationType.SMS,
        });
      }

      return items;
    }, [] as RawCommunicationPreference[]);
    await action(raw);
    await refetch();
    console.log('saved');
  };

  const onCancel = async () => {
    // Navigate back
    navigator(-1);
  };

  return {
    preferences: view,
    handleNotificationChanged: onNotificationChanged,
    handleSave: onSave,
    handleCancel: onCancel,
  };
};
